// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".order_table td:nth-of-type(3),.order_table td:nth-of-type(4),.order_table td:nth-of-type(9),.order_table td:nth-of-type(10),.order_table td:nth-of-type(11),.order_table td:nth-of-type(12){width:40px}", ""]);
// Exports
module.exports = exports;
